import { render, staticRenderFns } from "./CustomBottomSheet.vue?vue&type=template&id=20e474da&"
import script from "./CustomBottomSheet.vue?vue&type=script&lang=js&"
export * from "./CustomBottomSheet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports